var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import ReportService, { getContainerStyle, } from '../../Report/services/ReportService';
import Notification from '../../App/components/Notification';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LinearProgress from '@mui/material/LinearProgress';
function ProviderGoals() {
    // Formatação de números
    var formatNumber = function (num) {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(num);
    };
    // Dados dos boxes
    var _a = useState([]), marginsData = _a[0], setMarginsData = _a[1];
    // Controles do carregamento dos dados
    var _b = useState(true), isMarginsDataLoading = _b[0], setIsMarginsDataLoading = _b[1];
    // Controles dos accordions
    var _c = useState({}), expandedItems = _c[0], setExpandedItems = _c[1];
    var toggleExpand = function (id) {
        setExpandedItems(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[id] = !prev[id], _a)));
        });
    };
    useEffect(function () {
        // Busca dos dados para os boxes com as margens
        ReportService.getMarginsWithProducts()
            .then(function (response) {
            setMarginsData(response.data.margins_with_products);
            setExpandedItems(response.data.margins_with_products.reduce(function (acc, item) {
                acc[item.margin] = false;
                return acc;
            }, {}));
            setIsMarginsDataLoading(false);
        })
            .catch(function (error) {
            Notification().Notify.failure('Ocorreu um erro ao carregar os produtos por margens', error);
        });
    }, []);
    return (_jsxs("div", __assign({ className: "container-provider-goals" }, { children: [_jsx("h2", { children: "Suas metas" }), _jsx("div", __assign({ className: "profit-margin-container", style: getContainerStyle(isMarginsDataLoading) }, { children: marginsData.length === 0 ? (_jsx("div", __assign({ className: "profit-margin-accordion-box-no-content" }, { children: _jsx("span", { children: isMarginsDataLoading
                            ? 'Carregando margens...'
                            : 'Sem dados...' }) }))) : (marginsData.map(function (item) {
                    var isOpen = expandedItems[item.margin_group_id];
                    return (_jsxs("div", __assign({ className: "profit-margin-accordion-box", role: "button", tabIndex: 0, onClick: function () { return toggleExpand(item.margin_group_id); }, onKeyDown: function (e) {
                            if (e.key === 'Enter') {
                                toggleExpand(item.margin_group_id);
                            }
                        }, style: { cursor: 'pointer' } }, { children: [_jsxs("div", __assign({ className: "profit-margin-accordion-header" }, { children: [_jsxs("span", __assign({ className: "profit-margin-accordion-header-text" }, { children: ["MARGEM DE LUCRO:", ' ', _jsxs("b", { children: [formatNumber(item.margin), "% (", item.type, ")"] })] })), _jsx("span", __assign({ className: "profit-margin-accordion-toggle-button ".concat(isOpen ? 'rotated' : '') }, { children: _jsx(KeyboardArrowDownIcon, {}) }))] })), _jsxs("div", __assign({ className: "profit-margin-accordion-body ".concat(isOpen ? 'open' : 'closed') }, { children: [_jsx("hr", {}), _jsxs("div", __assign({ className: "profit-margin-accordion-body-content" }, { children: [item.text !== null && (_jsxs("div", __assign({ className: "profit-margin-information" }, { children: [_jsx("p", { children: item.text }), _jsxs("span", __assign({ className: "chip-margin-information" }, { children: [item.active, " /", ' ', item.last_qty] })), _jsxs("div", __assign({ className: "product-goals-progress-bar" }, { children: [_jsx(LinearProgress, { className: "product-goals-progress-bar-line", variant: "determinate", value: Math.min((item.active /
                                                                    item.last_qty) *
                                                                    100, 100) }), _jsxs("span", { children: [Math.round(Math.min((item.active /
                                                                        item.last_qty) *
                                                                        100, 100)), "%"] })] }))] }))), _jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", { children: ["Produtos:", ' ', item.qty_products] }), _jsxs("th", { children: ["Tokens: ", item.active] })] }) }), _jsx("tbody", { children: item.products.length > 0 ? (item.products.map(function (product) { return (_jsxs("tr", { children: [_jsx("td", { children: product.product_name }), _jsx("td", { children: product.active })] }, product.product_id)); })) : (_jsx("tr", { children: _jsx("td", __assign({ className: "text-center", colSpan: 2 }, { children: "Nenhum produto" })) })) })] })] }))] }))] }), item.margin_group_id));
                })) }))] })));
}
export default ProviderGoals;
